import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Date2m34sotjh4dpv as Date_0,
  toExcelValue3gg0xp798altl as toExcelValue,
  Text2b8ye3kmips1o as Text,
  Empty_getInstancey576bdifk14w as Empty_getInstance,
} from './ExcelValue.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { toString1n9qg6fb0b5i8 as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toExcelValues(_this__u8e3s4, value) {
  var kind = unwrapInline(_this__u8e3s4.get_descriptor_wjt6a0_k$()).get_kind_wop7ml_k$();
  if (!equals(kind, CLASS_getInstance()) && !equals(kind, OBJECT_getInstance()))
    throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Only classes can be flattened into Excel values. Got ' + kind.toString() + ' (' + _this__u8e3s4.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ').');
  var dest = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  ExcelValueEncoder().new_org_thecommunitygroupinc_cares_excel_ExcelValueEncoder_iesqsh_k$('', dest).encodeSerializableValue_3uuzip_k$(_this__u8e3s4, value);
  return dest;
}
function unwrapInline(_this__u8e3s4) {
  var $this = _this__u8e3s4;
  $l$1: do {
    $l$0: do {
      var tmp;
      if ($this.get_isInline_usk17w_k$()) {
        $this = $this.getElementDescriptor_ncda77_k$(0);
        continue $l$0;
      } else {
        tmp = $this;
      }
      return tmp;
    }
     while (false);
  }
   while (true);
}
var ExcelValueEncoderClass;
function ExcelValueEncoder() {
  if (ExcelValueEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor(prefix, dest) {
        return new.target.new_org_thecommunitygroupinc_cares_excel_ExcelValueEncoder_iesqsh_k$(prefix, dest);
      }
      static new_org_thecommunitygroupinc_cares_excel_ExcelValueEncoder_iesqsh_k$(prefix, dest) {
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$();
        $this.prefix_1 = prefix;
        $this.dest_1 = dest;
        $this.path_1 = $this.prefix_1;
        $this.serializersModule_1 = EmptySerializersModule();
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeElement_5v7eyb_k$(descriptor, index) {
        var name = descriptor.getElementName_u4sqmf_k$(index);
        var tmp = this;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.prefix_1;
        if (charSequenceLength(this_0) === 0) {
          tmp_0 = name;
        } else {
          tmp_0 = this.prefix_1 + '_' + name;
        }
        tmp.path_1 = tmp_0;
        return true;
      }
      beginStructure_yljocp_k$(descriptor) {
        if (!equals(descriptor.get_kind_wop7ml_k$(), CLASS_getInstance()) && !equals(descriptor.get_kind_wop7ml_k$(), OBJECT_getInstance()))
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Cannot convert ' + descriptor.get_kind_wop7ml_k$().toString() + ' (' + descriptor.get_serialName_u2rqhk_k$() + ") at '" + this.path_1 + "' to Excel values.");
        return ExcelValueEncoder().new_org_thecommunitygroupinc_cares_excel_ExcelValueEncoder_iesqsh_k$(this.path_1, this.dest_1);
      }
      encodeSerializableValue_3uuzip_k$(serializer, value) {
        if (value instanceof LocalDate()) {
          var tmp0 = this.dest_1;
          var tmp2 = this.path_1;
          // Inline function 'kotlin.collections.set' call
          var value_0 = new (Date_0())(value);
          tmp0.put_4fpzoq_k$(tmp2, value_0);
        } else {
          super.encodeSerializableValue_3uuzip_k$(serializer, value);
        }
      }
      encodeValue_g68i1f_k$(value) {
        var tmp0 = this.dest_1;
        var tmp2 = this.path_1;
        // Inline function 'kotlin.collections.set' call
        var value_0 = toExcelValue(value);
        tmp0.put_4fpzoq_k$(tmp2, value_0);
      }
      encodeChar_id8ngf_k$(value) {
        var tmp0 = this.dest_1;
        var tmp2 = this.path_1;
        // Inline function 'kotlin.collections.set' call
        var value_0 = new (Text())(toString(value));
        tmp0.put_4fpzoq_k$(tmp2, value_0);
      }
      encodeNull_ejiosz_k$() {
        var tmp0 = this.dest_1;
        var tmp2 = this.path_1;
        // Inline function 'kotlin.collections.set' call
        var value = Empty_getInstance();
        tmp0.put_4fpzoq_k$(tmp2, value);
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        var tmp0 = this.dest_1;
        var tmp2 = this.path_1;
        // Inline function 'kotlin.collections.set' call
        var value = new (Text())(enumDescriptor.getElementName_u4sqmf_k$(index));
        tmp0.put_4fpzoq_k$(tmp2, value);
      }
    }
    initMetadataForClass($, 'ExcelValueEncoder');
    ExcelValueEncoderClass = $;
  }
  return ExcelValueEncoderClass;
}
//region block: exports
export {
  toExcelValues as toExcelValues1jab7k1silffo,
};
//endregion

//# sourceMappingURL=ExcelSerialization.mjs.map
